import React, { useEffect, useMemo, useState } from "react";

// Import components
import TableContainer from '../../components/Common/DataTableContainer';
import { Button, Col, Label } from "reactstrap";
import { useDispatch } from "react-redux";
import { deleteTeam, updateTeam } from "store/actions"; // assuming these actions exist
import CreateTeam from "./CreateTeam"; // Component to handle creating/updating teams
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import Select from "react-select"

const TeamTable = ({ List,solutions, loading, shifts ,setSelectedSolution,selectedSolution,zones}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState();
  const [openModal, setOpenModal] = useState()
  const [confirmAction, setConfirmAction] = useState();

  const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

  const hasEditPermission = permissions2.some(item => item?.permissionName === "Edit Teams");
  const hasDeletePermission = permissions2.some(item => item?.permissionName === "Delete Teams");

  const handleDelete = (teamId) => {
    dispatch(deleteTeam(teamId, true))
    setDeleteId('')
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction])

  const columns = useMemo(
    () => [
      {
        header: 'Team Name',
        accessorKey: 'teamName',
        enableColumnFilter: false,
        enableSorting: true,
        // Add an onClick handler for the team name column
        cell: ({ row }) => (
          <span
            title="View Profile"
            style={{ cursor: 'pointer', color: "#04a1b6" }} // Optional styling for clickable text
            onClick={() => navigate(`/teamdetails/${row.original.teamId}`)} // Navigate to team details with id
          >
            {row.original.teamName}
          </span>
        ),
      },
      {
        header: 'Shift Name',
        accessorKey: 'shiftName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Break Time (mins)',
        accessorKey: 'breakTimeInMins',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Solution',
        accessorKey:'solutionName',
        enableColumnFilter: false
      },
      {
        header: 'Zones',
        accessorKey:'zoneName',
        enableColumnFilter: false
      },
      {
        header: 'Specialization',
        accessorKey: 'specialization',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Status',
        accessorKey: 'isActive',
        enableColumnFilter: false,
        enableSorting: true,
        cell:({row})=>{
          return(
            <span>{row.original.isActive ? "Active":"Inactive"}</span>
          )
        }
      },
      ...(hasEditPermission || hasDeletePermission ? [{
        header: 'Actions',
        id: 'actions', // Unique id for this column
        cell: ({ row }) => {
          const handleEdit = () => {
            const rowData = row.original;
            setEditData(rowData);
            setIsOpen(true);
            console.log('Edit clicked for row:', rowData);
          };

          const handleDelete = () => {
            const rowData = row.original;
            dispatch(deleteTeam(rowData.teamId));
          };

          return (
            <div className="d-flex gap-2">
              {permissions2?.map(item => item?.permissionName)?.includes("Edit Teams") && <Button color="primary" onClick={handleEdit} className="mr-2">
                <FaRegEdit size={18}/>
              </Button>}
              {permissions2?.map(item => item?.permissionName)?.includes("Delete Teams") && <Button
                color="danger"
                onClick={() => { setDeleteId(row?.original?.teamId); setOpenModal(true); }}
                className="mr-2"
              >
                <MdDeleteOutline size={18}/>
              </Button>}
            </div>
          );
        },
      },
      ] : []),
    ],
    []
  );

  const handleSubmit = (data,onClose) => {
    dispatch(updateTeam(data, true,onClose));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  // Meta title
  document.title = "Team Management | Admin Dashboard";

  return (
    <>
      <ConfirmationModal okText={"Confirm"} onCancel={() => { setDeleteId(''); setOpenModal(false);}} onOk={() => { setConfirmAction(true); }} isVisible={openModal} title="Delete Team" content='Are You Sure You Want to Delete the Team' />
      <CreateTeam
        solutions={solutions}
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
        shifts={shifts}
        zones={zones}
      />
      <div className="">
        <div className="container-fluid">
        <Col xs={6} md={3} className="mb-4">
            <Label for="solution" className='mt-1'>Solution</Label>
            <Select
              id="solution"
              options={solutions?.map(item => ({ label: item?.solutionName, value: item?.solutionId }))}
              value={solutions?.map(item => ({ label: item?.solutionName, value: item?.solutionId }))?.find(option => option?.value == selectedSolution) || ""}
              onChange={option => { setSelectedSolution(option?.value); }}
              placeholder="Select Solution"
              isClearable={true}
              styles={{
                container: (base) => ({
                  ...base,
                  maxWidth: '200px',
                }),
              }}
            />
          </Col>
          <TableContainer
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Teams"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default TeamTable;
